import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";
import * as React from "react";

import {color, spacing} from "@khanacademy/wonder-blocks-tokens";

import BaseToastNotification from "../components/base-toast-notification.tsx";

const ChangesSavedNotification = (props: {
    message?: string;
}): React.ReactElement => {
    return (
        <BaseToastNotification
            style={styles.toast}
            closeIconColor={color.white}
        >
            {props.message || t`Your changes have been saved.`}
        </BaseToastNotification>
    );
};

const styles = StyleSheet.create({
    toast: {
        backgroundColor: color.blue,
        color: color.white,
        width: "auto",
        marginLeft: spacing.medium_16,
        marginRight: spacing.medium_16,
    },
});

export default ChangesSavedNotification;
